import React from 'react';
import { Link } from 'react-router-dom';
import './Landing.css';

export default function Landing() {
  return (
    <div className="landing">
      {/* Background */}
      <div className="landing-bg">
        <div className="orb orb-1" />
        <div className="orb orb-2" />
        <div className="orb orb-3" />
        <div className="grid-overlay" />
      </div>

      {/* Nav */}
      <nav className="landing-nav">
        <div className="logo">
          <span className="logo-icon">◈</span>
          <span className="logo-text">NOTE <span>APEX</span></span>
        </div>
        <div className="nav-links">
          <Link to="/login" className="btn btn-ghost">Sign In</Link>
          <Link to="/register" className="btn btn-primary">Get Started Free</Link>
        </div>
      </nav>

      {/* Hero */}
      <section className="hero">
        <div className="hero-badge">✦ Your thoughts, elevated</div>
        <h1 className="hero-title">
          Capture Every<br />
          <span className="gradient-text">Idea. Anywhere.</span>
        </h1>
        <p className="hero-desc">
          NOTE APEX is your intelligent personal notebook — write notes, journal entries,
          code snippets, and to-dos. Access everything from any device, anytime.
        </p>
        <div className="hero-actions">
          <Link to="/register" className="btn btn-primary btn-lg">
            Start for Free →
          </Link>
          <Link to="/login" className="btn btn-ghost btn-lg">
            Sign In
          </Link>
        </div>
        <p className="hero-note">No credit card required, Free </p>
      </section>

      {/* Features */}
      <section className="features">
        {[
          { icon: '📝', title: 'Rich Notes', desc: 'Write with a full rich-text editor. Bold, italic, lists, links, and more.' },
          { icon: '📔', title: 'Personal Journal', desc: 'Keep a private daily diary. Reflect, grow, and track your journey.' },
          { icon: '💻', title: 'Code Snippets', desc: 'Store and organize code with syntax-aware formatting.' },
          { icon: '🖼️', title: 'Image Embed', desc: 'Attach and embed images directly in your notes.' },
          { icon: '🔍', title: 'Instant Search', desc: 'Find anything in milliseconds across all your notes.' },
          { icon: '🌍', title: 'Any Device', desc: 'Access your notes from phone, tablet, or desktop anywhere in the world.' },
        ].map((f, i) => (
          <div key={i} className="feature-card fade-in" style={{ animationDelay: `${i * 0.08}s` }}>
            <div className="feature-icon">{f.icon}</div>
            <h3>{f.title}</h3>
            <p>{f.desc}</p>
          </div>
        ))}
      </section>

      {/* CTA */}
      <section className="cta-section">
        <h2>Ready to organize your mind?</h2>
        <p>Join thousands of users who trust NOTE APEX with their most important thoughts.</p>
        <Link to="/register" className="btn btn-primary btn-lg">Create Your Free Account</Link>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="logo">
          <span className="logo-icon">◈</span>
          <span className="logo-text">NOTE <span>APEX</span></span>
        </div>
        <p>© {new Date().getFullYear()} NOTE APEX - Created by SUMEETH NAIK Open source & free.</p>
      </footer>
    </div>
  );
}
